import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { Popup } from 'vant';
import { Loading } from 'vant';
import { Dialog } from 'vant';
import { Field, CellGroup } from 'vant';
import 'vant/lib/index.css'
import VConsole from 'vconsole'

// 初始化vconsole：判断地址栏有vconsole字段就渲染
if (location.hash.includes('vconsole')) {
    new VConsole();
}

const app = createApp(App)

app.use(Loading);
app.use(Field);
app.use(CellGroup);
app.use(Popup);
app.use(Dialog);
app.use(store).use(router).mount('#app')
